import { Alert, Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import TopicSelectionStep from '../wizard_steps/TopicSelectionStep';
import TestProjectBaselineImpactList from '../TestProjectBaselineImpactList';

import type { TestProjectInputDialogProps } from './types';

export type TestProjectInputEditContentProps = TestProjectInputDialogProps & {
    confirmation: boolean;
};

export const TestProjectInputEditContent = observer(
    ({ store, draft, confirmation }: TestProjectInputEditContentProps) => {
        const { inputSelectionStore, prepared } = draft;

        const error = draft.error || inputSelectionStore.metadataError;

        return (
            <>
                {error && (
                    <Alert
                        message={error}
                        style={{ marginBottom: 16 }}
                        type="error"
                        action={
                            inputSelectionStore.metadataError && (
                                <Button onClick={store.retryMetadata} disabled={!store.canEdit}>
                                    Retry
                                </Button>
                            )
                        }
                    />
                )}
                {confirmation ? (
                    <>
                        <p>
                            Saving this change will replace the current tag inputs and{' '}
                            <strong>permanently delete their existing baselines</strong>. The new bindings will start
                            with empty baselines.
                        </p>
                        {prepared?.impact && <TestProjectBaselineImpactList inputs={prepared.impact.removed} />}
                    </>
                ) : (
                    <TopicSelectionStep
                        store={inputSelectionStore}
                        warnOnRemoval
                        disabled={!store.canEdit}
                        onConfirmTopicRemoval={store.requestTopicRemoval}
                    />
                )}
            </>
        );
    }
);
